import { Stack, Typography } from '@mui/material'
import { com } from '@eidu/form'
import SemanticLinksStack from './SemanticLinksStack'
import AuthenticationContext from '../../api/authorization/AuthenticationContext'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink

type EntityTypesStackProps = {
  authContext: AuthenticationContext
  kind: EntityTypeKind
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
  onSemanticLinksChange: () => void
}

const EntityTypesStack = ({
  authContext,
  kind,
  entityTypes,
  semanticLinks,
  onSemanticLinksChange,
}: EntityTypesStackProps) => (
  <Stack direction="column">
    <Typography variant="h6">{`${kind.name} Types`}</Typography>
    <Stack paddingY={2} spacing={1}>
      {entityTypes.map(
        (entityType) =>
          entityType.kind === kind && (
            <SemanticLinksStack
              authContext={authContext}
              key={entityType.id.toString()}
              entityTypes={entityTypes}
              entityType={entityType}
              semanticLinks={semanticLinks.filter(({ path }) => path.fromType.equals(entityType.id))}
              onSemanticLinksChange={onSemanticLinksChange}
            />
          )
      )}
    </Stack>
  </Stack>
)

export default EntityTypesStack
